<template>
	<div>
		<div
			class="modal fade modal-fullscreen-mobile"
			ref="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
		>
			<div class="modal-dialog vld-parent" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h1 class="modal-title">New Credit Card</h1>
						<button
							type="button"
							class="modal-close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<i class="sk-icon-times"></i>
						</button>
					</div>
					<div class="modal-body">
						<loading :active="loading" />
						<div class="new-cc-modal" id="form-container">
							<div id="sq-card-number"></div>
							<div id="sq-expiration-date"></div>
							<div id="sq-cvv"></div>
							<div id="sq-postal-code"></div>
							<input type="hidden" id="card-nonce" name="nonce" />
						</div>
						<button
							class="button button-primary"
							id="sq-creditcard"
							@click="requestCardNonce"
						>
							Add Payment Method
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
.new-cc-modal #sq-expiration-date,
.new-cc-modal #sq-cvv,
.new-cc-modal #sq-postal-code {
	width: calc((100% - (20px * 2)) / 3);
}
</style>

<style scoped>
.modal-body #sq-creditcard {
	margin-top: 30px;
}
</style>

<script>
import { NotificationType } from "@/enums/NotificationType"
import { eventBus, EventBusEvents } from "@/eventBus"
import squareFormMixin from "@/mixins/square-form-mixin"
import Loading from "vue-loading-overlay"

export default {
	name: "NewCreditCardModal",
	mixins: [squareFormMixin],
	components: {
		Loading
	},
	data: function() {
		return {
			configureDigitalWallets: false,
			loading: false
		}
	},
	methods: {
		open() {
			this.loading = false
			$(this.$refs.modal).modal("show")
		},
		close() {
			$(this.$refs.modal).modal("hide")
		},
		async chargeCard(nonce) {
			try {
				this.loading = true
				const added = await this.$store.dispatch("addUserCreditCard", {
					nonce: nonce,
					zipcode: this.zipcode
				})
				if (added) {
					this.close()
					this.loading = false
				} else {
					throw "Unable to add credit card"
				}
			} catch (e) {
				this.loading = false
				eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
					message: e.message ? e.message : e,
					type: NotificationType.ERROR
				})
			}
		}
	}
}
</script>
